// 增强 APP:Uploadkit 功能的脚本，依赖 jquery（在 main-product.liquid 已经引入）
// 1. 上传弹窗中，preview 列表增加数量选择器

console.log('%cuploadkit-enhance.js is running', 'border: 2px solid purple; padding: 5px; box-shadow: 2px 2px 5px gray;');

// shopify 产品页面-公共大表单
let pqProductForm = jQuery(".product-form").find("form");
// 大表单中增加 pq container，存放：图片对应的数量...
pqProductForm.append(
  '<div id="pq-properties-container" style="display: none;"></div>'
);
// pq 私有表单
let pqPropertiesContainer = $("#pq-properties-container");

// intervals
let allUploadedInterval = 0;
let doneInterval = 0;

// 打开上传弹窗触发
// 定义一个回调函数，当观察到 DOM 变化时会被调用
const callback = (mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      // 遍历新增的节点
      for (const addedNode of mutation.addedNodes) {
        // 如果 DOM 中增加了 .uploadcare--dialog
        if (
          addedNode.nodeType === Node.ELEMENT_NODE &&
          // dom: uploadcare 弹窗
          addedNode.classList.contains("uploadcare--dialog")
        ) {

          // 内部上传区
          // dom: uploadcare 弹窗中的上传预览列表
          const previewList = addedNode.querySelector(
            "div.uploadcare--files.uploadcare--files_type_table"
          );
          if (previewList) {
            // 清除之前的轮询
            clearInterval(allUploadedInterval);
            // 每隔一段时间轮询
            // NOTE: 因为目前按钮长按快速加减的实现原因，发生了轮询嵌套，如果这块还是原来的 1s，在交互上就会每 1s 出现一个数量选择器
            allUploadedInterval = setInterval(() => {
              // HACK: 隐藏uploadkit裁剪图片弹窗中背景中的出血线图，需配合 main-product.liquid 的 css 修改
              var second = jQuery(".uploadcare--jcrop-tracker").eq(1);
              // 添加一个自定义 class
              second.addClass("hide-after-bg");
              
              // 只要 dialog 开着就每隔 1s check 一下
              if (
                jQuery(".uploadcare--dialog.uploadcare--dialog_status_active")
                  .length == 0
              ) {
                // 轮询检测到弹窗关闭
                // 清除轮询
                clearInterval(allUploadedInterval);

                // 开启新的一种轮询，根据预览区的图片数量来判断是否剩余图片上传完毕
                // 增加 200ms 延时，关闭弹窗后等 react dom 刷新预览区
                setTimeout(() => {
                  // 预览区没有进度条，说明上传完毕
                  // dom: uploadkit 预览区
                  if (
                    jQuery(".uploadkit-thumbnails").first().find(".uploadkit-progressbar")
                      .length == 0
                  ) {
                    console.log('all uploaded');
                    deleteAndRenameFormInputs();
                    addWrapperToPreviewImgs();
                  } else {
                    console.log('not all uploaded');
                    // 先清轮询
                    clearInterval(doneInterval);
                    // 每一秒轮询一下预览区
                    doneInterval = setInterval(() => {
                      // 预览区容器
                      jQuery(".uploadkit-thumbnails").first()
                        .children()
                        .each(function (domIndex, domElement) {
                          // 如果是进度条，则跳过这一轮
                          if (
                            jQuery(domElement).hasClass(
                              "uploadkit-progressbar"
                            )
                          ) {
                            return true;
                          }

                          // 如果没有 src，也说明还没上传完
                          if(!domElement.src) return true;

                          // 找到这个 item 对应图片的 uuid
                          let uuid = domElement.src.split("/")[3];

                          // 在页面pq-properties-container中创建一条数据，默认数量为1
                          if (jQuery(`#pq-${uuid}`).length == 0) {
                            pqPropertiesContainer.append(
                              `<input type="hidden" id="pq-${uuid}" name="properties[${uuid}]" value="1">`
                            );
                          }
                        });
                      // 循环处理一遍预览图之后，如果发现预览图没有上传进度条，说明都完成了，于是整理 pq input，并 clearinterval
                      if (
                        jQuery(".uploadkit-thumbnails").first().find(".uploadkit-progressbar")
                          .length == 0
                      ) {
                        console.log('all uploaded1');
                        deleteAndRenameFormInputs();
                        addWrapperToPreviewImgs();
                        clearInterval(doneInterval);
                      }
                    }, 1000);
                  }
                }, 200);

                function addWrapperToPreviewImgs() {
                  // 给每个预览图加一个 wrapper，展示图的数量
                  $('.uploadkit-thumbnails .uploadkit-thumbnail').each(function() {
                    const $img = $(this);
                    let uuid = this.src.split('/-/')[0].split('/').slice(-1)[0]
                    // 有可能取的时候对应的 input 还没建立好，这个时候给默认值 1
                    let amount = jQuery(`#pq-${uuid}`).val() ? jQuery(`#pq-${uuid}`).val() : 1

                    function addMask() {
                      // 检测如果已经包过了
                      if ($img.parent().hasClass('img-wrapper')) {
                        // 如果已经包过了，就删除遮罩，重新包一层 
                        $img.next('.img-mask').remove();
                        $img.unwrap();
                      }

                      // 包一层 div
                      $img.wrap('<div class="img-wrapper" style="position:relative; display:inline-block;"></div>');

                  
                      // 在 img 后面插入遮罩
                      const $mask = $(`<div class="img-mask">${amount}</div>`);
                      $mask.css({
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: $img.width(),
                        height: $img.height(),
                        lineHeight: $img.height() + 'px',
                        textAlign: 'center',
                        color: '#fff',
                        background: 'rgba(0,0,0,0.3)',
                        pointerEvents: 'none'
                      });
                      $img.after($mask);

                      // 增加点击打开 dialog 滚动到对应的位置
                      $img.parent().off('click').on('click', function() {
                        setTimeout(() => {
                          const index = $img.parent().index(); // 获取点击的 img-wrapper 的索引
                      
                          const $filesContainer = $('.uploadcare--files');
                          const $targetItem = $filesContainer.children().eq(index); // 获取对应的 file-item
                        
                          if ($targetItem.length) {
                            // 相对于文件容器顶部的位置
                            const scrollTop = $targetItem.offset().top - $filesContainer.offset().top + $filesContainer.scrollTop();
                        
                            $filesContainer.animate({ scrollTop: scrollTop }, 300);
                          }
                        }, 1000);
                      })
                    }

                    // 展示 sum
                    let sumAmount = 0
                    $("#pq-properties-container input").each(function () {
                      let val = parseFloat($(this).val());
                      if (!isNaN(val)) {
                        sumAmount += val;
                      }
                    });
                    // 替换 uploadkit label 的文字
                    $('.uploadkit-label').find('span').css('color', '#a30077').text('Uploaded images: ' + sumAmount)
                  
                    if (this.complete) {
                      // 如果图片已经加载完了（比如缓存中）
                      addMask();
                    } else {
                      // 等待图片加载
                      $img.on('load', addMask);
                    }
                  });
                }

                function deleteAndRenameFormInputs() {
                  console.log('deleteAndRenameFormInputs')
                  // 删除多余的 input（在上传区域点击垃圾桶导致）
                  // 根据 .uploadkit-thumbnails 获取发往购物车的图片
                  const validIds = [];
                  jQuery(
                    ".uploadkit-thumbnails .uploadkit-thumbnail"
                  ).each(function () {
                    let srcValue = "pq-" + $(this).attr("src").split("/")[3];
                    if (srcValue) {
                      validIds.push(srcValue);
                    }
                  });
                  // 获取 id 为 pq-properties-container 的元素下的所有 input 子元素
                  // 根据 id 判断是否需要删除
                  $("#pq-properties-container input").each(function () {
                    const inputId = $(this).attr("id");
                    if (!validIds.includes(inputId)) {
                      $(this).remove();
                    }
                  });

                  // input name 重命名，以在购物车和后台更直观看到哪个图的数量是多少
                  // 从 uploadkit 表单区取出图片列表上传信息
                  // dom: uploadkit 表单区
                  let ukInputs = jQuery('.uploadkit-attribute-container input[name^="properties[_Uploaded"]')
                  ukInputs.each(function (domIndex, domElement) {
                    let uuid = domElement.value.split('/')[4]
                    let newName = `properties[${domElement.name.split('[_')[1].split('(')[0]}quantity]`
                    // 找到相同 uuid 的 pq input，修改 name
                    let pqInput = jQuery(`#pq-${uuid}`)
                    if (pqInput.length > 0) {
                      pqInput.attr('name', newName)
                    }
                  })
                  // 对 input 进行排序，有时候用户删除、拖拽等操作会让 input 顺序错乱
                  let sortedInputs = pqPropertiesContainer
                    .children("input")
                    .sort(function (a, b) {
                      return (
                        parseInt(a.name.split(' ')[2]) -
                        parseInt(b.name.split(' ')[2])
                      );
                    });
                  pqPropertiesContainer.empty();
                  pqPropertiesContainer.append(sortedInputs);
                }
              } else {
                // 轮询检测到弹窗开着
                // 存放 sum（上传*数量）
                let uploadSum = 0;

                // 遍历 uploaded list
                // 找到哪些图片传完了，在各自子元素的步骤条后面 append 一个 input，并创建隐藏 input
                // NOTE: 用户开着弹窗可能随时追加上传
                jQuery(previewList)
                  .find(".uploadcare--file_status_uploaded")
                  .each(function (domIndex, domElement) {
                    // 如果已经有了数量选择器，则跳过这一轮
                    if (jQuery(this).find(".pq-amout").length > 0) {
                      // 如果已经有选择器，就把选择器的数量加到 sum 上
                      uploadSum += Number(jQuery(this).find(".pq-amout").find(".pq-a-2").text())
                      return true;
                    }

                    // 追加样式：在左侧 image 上面增加一个浮层，提示可点击编辑
                    if(jQuery(domElement).find(".pq-upload-item-edit-decoration").length == 0) {
                      jQuery(domElement).find('.uploadcare--file__preview').css('position', 'relative').prepend(jQuery(`<div class="pq-upload-item-edit-decoration" style="position: absolute;bottom: 0;background: rgba(0,0,0,0.25);width: inherit;text-align: center;">Edit</div>`))
                    }

                    // 找到这个 item 对应图片的 uuid
                    let uuid = jQuery(this)
                      .find("img.uploadcare--file__icon")[0]
                      .src.split("/")[3];

                    // 在页面pq-properties-container中创建一条数据
                    if (jQuery(`#pq-${uuid}`).length == 0) {
                      pqPropertiesContainer.append(
                        `<input type="hidden" id="pq-${uuid}" name="properties[${uuid}]" value="1">`
                      );
                    }

                    // 给每个 item 增加一组数量选择器
                    let itemNumber = 1;
                    if (jQuery(`#pq-${uuid}`).length > 0) {
                      itemNumber = jQuery(`#pq-${uuid}`).first().val();
                    }
                    $(this)
                      .find(".uploadcare--file__progressbar")
                      .after(
                        `<div class="pq-amout" style="margin-right: 12px;display: flex;height: 50%;margin-top: 16px;">
                        <div class="pq-a-2" style="line-height: 29px; margin: 0 48px 0 0;border: 1px solid black;padding: 0 4px;border-radius: 4px;">${itemNumber}</div>
                        <div class="pq-a-3 pq-a-stepper" data-action="decrement" style="margin-top: 5px; margin-right: 16px; cursor: pointer;">➖</div>
                        <div class="pq-a-1 pq-a-stepper" data-action="increment" style="margin-top: 5px; margin-right: 16px; cursor: pointer;">➕</div>
                        </div>`
                      );
                    
                    
                    // 新创建的默认是 1
                    uploadSum += 1
                    // 按钮绑定事件
                    // 长按加减数字快速变化
                    let intervalId = null; // 用于存储 setInterval 的 ID
                    let timeoutId = null;  // 用于存储 setTimeout 的 ID
                    const longPressDelay = 400; // 长按多久后开始快速变化 (毫秒)
                    const repeatInterval = 100; // 快速变化时每次变化的间隔 (毫秒)

                    let currentNumber = $(this).find('.pq-a-2').text(); // 当前数字
                    const displayElement = $(this).find('.pq-a-2'); // 显示数字的元素

                    // --- 更新显示的函数 ---
                    function updateDisplay() {
                      displayElement.text(currentNumber);
                      // 可选：在这里添加禁用按钮的逻辑，如果数字有范围限制
                      // $('#decrementBtn').prop('disabled', currentNumber <= 0); // 示例：最小值为 0
                      // $('#incrementBtn').prop('disabled', currentNumber >= 100); // 示例：最大值为 100
                    }
                    // --- 清除定时器 ---
                    function clearTimers() {
                      clearTimeout(timeoutId);
                      clearInterval(intervalId);
                      timeoutId = null;
                      intervalId = null;
                    }
                    // --- 执行增加或减少操作 ---
                    function performAction(action) {
                      if (action === 'increment') {
                        // 可选：检查是否达到最大值
                        // if (currentNumber >= 100) return;
                        currentNumber++;
                      } else if (action === 'decrement') {
                        // 可选：检查是否达到最小值
                        if (currentNumber <= 1) return;
                        currentNumber--;
                      }
                      // 更新 pq 隐藏表单域
                      jQuery(`#pq-${uuid}`).val(currentNumber);
                      // 更新显示
                      updateDisplay();
                    }
                    // --- 绑定事件 ---
                    $(this).find('.pq-a-stepper').on('mousedown touchstart', function(e) {
                      // 1. 阻止默认行为（如触摸屏上的长按菜单或文本选择）
                      e.preventDefault();

                      const action = $(this).data('action'); // 获取是 'increment' 还是 'decrement'

                      // 2. 立即执行一次操作（单击效果）
                      performAction(action);

                      // 3. 设置一个延时器，若按下时间超过 longPressDelay，则启动重复执行
                      timeoutId = setTimeout(() => {
                        // 4. 启动重复执行的定时器
                        intervalId = setInterval(() => {
                          performAction(action);
                        }, repeatInterval);
                      }, longPressDelay);

                    }).on('mouseup mouseleave touchend touchcancel', function() {
                      // 5. 当鼠标松开、移出按钮、触摸结束或取消时，清除所有定时器
                      clearTimers();
                    });
                    // 禁止选中和出现拖蓝
                    if($(this).find('.pq-a-stepper').length > 0) {
                      $(this).find('.pq-a-stepper').on('contextmenu', (e) => {
                        e.preventDefault();
                      });
                      $(this).find('.pq-a-stepper').on('selectstart', (e) => {
                        e.preventDefault(); // 禁止选中文字（某些安卓机）
                      });
                    }
                  });
                  
                  // 在原来的 title 后面追加 images 总数
                  let previewTitle = jQuery("#preview__title").text()
                  if(previewTitle.indexOf("(") > -1) {
                    previewTitle = jQuery("#preview__title").text().split("(")[0] + `(${uploadSum} images)`
                  } else {
                    previewTitle = jQuery("#preview__title").text() + `(${uploadSum} images)`
                  }
                  jQuery("#preview__title").text(previewTitle)
                }
            }, 100);
          } else {
            console.log("未找到 uploadcare dialog");
          }
        }
      }
    }
  }
};

// 页面卸载前清除轮询
window.addEventListener("beforeunload", () => {
  clearInterval(allUploadedInterval)
  clearInterval(doneInterval)
});

// 创建一个 MutationObserver 实例，并传入回调函数
const observer = new MutationObserver(callback);
// 获取要观察的目标节点
const targetNode = document.getElementsByTagName("body")[0];
// 配置观察选项，这里监听子节点的添加和移除
const config = { childList: true };
// 开始观察目标节点
observer.observe(targetNode, config);
